import { useMedia } from '../hooks/useMedia';
import { variables } from '../components/themes/variables';
export const useIsViewportMobile = () => useMedia({ maxWidth: variables.screenTablet - 1 });
export const useIsViewportTablet = () => useMedia({
    minWidth: variables.screenTablet,
    maxWidth: variables.screenLaptop - 1,
});
export const useIsViewportDesktop = () => useMedia({ minWidth: variables.screenLaptop });
